export function isEnumValue<T extends Record<string, string>>(enumType: T, value: string): value is T[keyof T] {
    return Object.values(enumType).includes(value as T[keyof T]);
}
